module.exports = __webpack_public_path__ + "img/economia.bf51db7e.png";